export var getPropertyAmenities = function getPropertyAmenities(amenities) {
  return amenities.map(function (amenity, index) {
    return index === 0 ? amenity : " \xB7 ".concat(amenity);
  }).join('');
};